@if (parentEntities().length > 0) {
  <div class="parent-context-banner">
    <!-- Parent Breadcrumb -->
    <div class="parent-breadcrumb">
      <div class="breadcrumb-entities">
        @for (entity of parentEntities(); track entity.label; let last = $last) {
          <div class="breadcrumb-entity">
            <i class="material-symbols-rounded">{{ entity.icon }}</i>
            <span class="breadcrumb-type">{{ entity.label }}</span>
            <span class="breadcrumb-value">{{ entity.value }}</span>
          </div>
          @if (!last) {
            <i class="material-symbols-rounded breadcrumb-sep">chevron_right</i>
          }
        }
      </div>
      <span class="breadcrumb-label">Importing under</span>
    </div>
  </div>
}
